import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

let initialized = false;
let currentMeasurementId = '';

function injectGA(measurementId: string) {
  if (initialized && currentMeasurementId === measurementId) return;

  const existing = document.getElementById('ga-script');
  if (existing) existing.remove();

  const script1 = document.createElement('script');
  script1.id = 'ga-script';
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });

  initialized = true;
  currentMeasurementId = measurementId;
}

async function loadGAConfig(): Promise<{ measurementId: string; enabled: boolean }> {
  const { data } = await supabase
    .from('system_settings')
    .select('key, value')
    .eq('category', 'analytics');

  if (!data) return { measurementId: '', enabled: false };

  const idRow = data.find(r => r.key === 'ga_measurement_id');
  const enabledRow = data.find(r => r.key === 'ga_enabled');

  return {
    measurementId: idRow?.value || '',
    enabled: enabledRow?.value === true || enabledRow?.value === 'true'
  };
}

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    loadGAConfig().then(({ measurementId, enabled }) => {
      if (enabled && measurementId) {
        injectGA(measurementId);
      }
    });
  }, []);

  useEffect(() => {
    if (!initialized || !currentMeasurementId) return;
    window.gtag('config', currentMeasurementId, {
      page_path: location.pathname + location.search
    });
  }, [location]);
}
